import { render, staticRenderFns } from "./RichInput.vue?vue&type=template&id=0c787230&"
import script from "./RichInput.vue?vue&type=script&lang=js&"
export * from "./RichInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports